import PaginationPage from "@components/pagination/pagination";
import React from "react";

function FooterWrapper(props: any) {
  const {
    list,
    totalCount,
    limit,
    page_no,
    handleChangePagination,
    handleChangeLimit,
    hideCount,
  } = props;
  return (
    <div>
      {totalCount != 0 && (
        <div className="footer-wrapper d-flex justify-content-between">
          {list.length > 0 && (
            <></>
            // <img src="/images/building-illustration.svg" className="img-fluid" />
          )}
          {totalCount > 10 ? (
            <PaginationPage
              totalCount={totalCount}
              limit={limit}
              pageNumber={page_no}
              handleChangePagination={handleChangePagination}
              handleChangeLimit={handleChangeLimit}
            />
          ) : (
            !hideCount && (
              <p className="show-rows-count mt-3 d-flex px-4">
                Total Count - &nbsp;&nbsp; <p>{totalCount}</p>
              </p>
            )
          )}
        </div>
      )}
    </div>
  );
}

export default FooterWrapper;
